/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class TokensProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * revalidate an issued JWT whose whitelist key is missing
   * Verifies the JWT signature and the MongoDB token record (not rejected, not expired), then restores the `jwt:<jti>` Redis whitelist key (best effort) as a short-lived unconfirmed entry, upgraded to the token's lifetime after a post-restore liveness recheck. Called by the JWT middleware on a whitelist miss so sessions survive Redis incidents; a rejected or expired token stays rejected.
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public postApiServicesecurityProcessesTokensRevalidate(
    requestBody: {
      /**
       * full signed JWT to revalidate
       */
      token: string;
    },
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/tokens/revalidate',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `missing or malformed token body attribute`,
        401: `token signature invalid, unknown, rejected or expired`,
      },
    });
  }

}
